import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

export default function EditStudentDetails() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, examId } = location.state || {};
  const focusInputRef = useRef(null); // Ref for the username input
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    rollNumber: '',
    subjects: [],
  });
  const currentPath = location?.pathname || '';
  const [subjectOptions, setSubjectOptions] = useState([]);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();

    // Fetch subjects for the multi-select options
    axios
      .get(`${apiUrl}/api/subject/list/${examId}`, {
        headers: {
          Authorization: `${localStorage.getItem('token')}`,
        },
      })
      .then((res) => {
        const options = res.data.subjectExam.map((subject) => ({
          value: subject.subjectCode, // Use subjectCode as value
          label: `${subject.subjectname} (${subject.subjectCode})`, // Label with subject name and code
        }));
        setSubjectOptions(options);
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        toast.error(
          err.response?.data?.message ||
            'An error occurred while fetching subjects'
        );
      });

    if (id) {
      // Fetch student details if id is available
      axios
        .get(`${apiUrl}/api/students/${id}`, {
          headers: {
            Authorization: `${localStorage.getItem('token')}`,
          },
        })
        .then((res) => {
          const subjects = res.data.subjectCode.map((subject) => {
            const subjectName = Object.keys(subject)[0];
            const subjectCode = Object.values(subject)[0];
            return {
              value: subjectCode,
              label: `${subjectName} (${subjectCode})`,
            };
          });
          setFormData({
            name: res.data.name,
            rollNumber: res.data.rollNumber,
            examId: res.data.examId,
            subjects: subjects,
          });
        })
        .catch((err) => {
          err.response?.status === 401 && navigate('/');
          toast.error(
            err.response?.data?.message ||
              'An error occurred while fetching student details'
          );
        });
    }
  }, [id, navigate, apiUrl]);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };
  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const token = localStorage.getItem('token');

    // Prepare the subjectCode payload with proper mapping
    const subjectCodePayload = formData.subjects.map((subject) => {
      return {
        [subject.label.split(' (')[0]]: subject.value, // Create object with name as key and code as value
      };
    });

    const payload = {
      name: formData.name,
      rollNumber: formData.rollNumber,
      examId: formData.examId,
      subjectCode: subjectCodePayload,
    };

    const requestMethod = id ? 'put' : 'post';
    const requestUrl = id
      ? `${apiUrl}/api/students/${id}`
      : `${apiUrl}/api/students`;

    axios({
      method: requestMethod,
      url: requestUrl,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: payload,
    })
      .then((res) => {
        setIsLoading(false);
        toast.success('Student details saved successfully');
        focus();
        if (currentPath === '/EditStudentDetails') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/EditStudentDetails') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        setIsLoading(false);
        toast.error(
          err.response?.data?.message ||
            'An error occurred while saving student details'
        );
      });
  };

  const handleChange = (selectedOptions) => {
    setFormData((prevState) => ({
      ...prevState,
      subjects: selectedOptions || [],
    }));
  };

  return (
    <>
      <AdminLayout ac6="active">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  {' '}
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-1)}>
                    Exams for Student
                  </span>
                </li>
                <li className="breadcrumb-item active">Edit Student Details</li>
              </ol>
            </nav>
          </div>

          <div className="row text-center">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body mt-5 mx-3">
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="row row-cols-2">
                        <div className="col-6">
                          <div className="form-floating mb-2">
                            <input
                              ref={focusInputRef}
                              className="form-control"
                              type="text"
                              name="rollNumber"
                              value={formData.rollNumber}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  rollNumber: e.target.value,
                                })
                              }
                              placeholder="Roll Number"
                              required
                            />
                            <label
                              className="form-label"
                              htmlFor="txtRollNumber"
                            >
                              Roll Number <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                })
                              }
                              placeholder="Name"
                              required
                            />
                            <label className="form-label" htmlFor="txtName">
                              Name <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>

                        <div className="mb-4">
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            name="subjectIds"
                            options={subjectOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={formData.subjects}
                            onChange={handleChange}
                            placeholder="Select Subjects"
                          />
                        </div>

                        <div className="col-12">
                          <div className=" text-end">
                            <button
                              type="button"
                              className="btn btn-primary px-3"
                              onClick={() => navigate(-1)}
                            >
                              <i className="bi bi-arrow-bar-left"></i> Back
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary px-4 mx-2"
                              disabled={isLoading}
                            >
                              {isLoading ? 'Saving...' : 'Save'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ms-4">
                      {/* Additional rows if needed */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </AdminLayout>
    </>
  );
}
